// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__13CeX","label":"styles_label__6GLxK"};